export const getUserFullNameByFL = (firstName?: string, lastName?: string) => {
  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }
  return firstName || lastName || '';
};

export const getUserFullName = (user?: {
  firstName?: string; lastName?: string
}) => getUserFullNameByFL(user?.firstName, user?.lastName);
